import React, { useState, useEffect } from "react";
import api from "../api";

const HeroSectionEdit = ({ editing }) => {
  const [currentLang, setCurrentLang] = useState("ua");
  const [form, setForm] = useState({
    ua: { title: "", description: "", image: "" },
    en: { title: "", description: "", image: "" },
  });

  useEffect(() => {
    if (editing?.value) {
      setForm(editing.value);
    }
  }, [editing]);

  const handleChange = (path, value) => {
    const keys = path.split(".");
    setForm((prev) => {
      const updated = { ...prev };
      let obj = updated;
      keys.forEach((k, i) => {
        if (i === keys.length - 1) obj[k] = value;
        else obj[k] = { ...obj[k] };
        obj = obj[k];
      });
      return updated;
    });
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
    const uploadPreset = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

    if (!cloudName || !uploadPreset) {
      alert("Cloudinary не налаштовано. Перевір .env");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", uploadPreset);

    try {
      const res = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/image/upload`, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      if (data.secure_url) {
        handleChange(`${currentLang}.image`, data.secure_url);
      } else {
        console.error("Cloudinary Error:", data);
        alert("Помилка при завантаженні зображення. Перевір консоль.");
      }
    } catch (err) {
      console.error("Помилка завантаження:", err);
      alert("Не вдалося завантажити зображення");
    }
  };

  const saveEdit = async () => {
    try {
      const existing = editing.value || {};

      const merged = { ...existing };

      ["ua", "en"].forEach((lang) => {
        merged[lang] = {
          ...existing[lang],
          ...form[lang],
          button1: existing[lang]?.button1 || { link: "/catalog", text: "Переглянути колекцію" },
          button2: existing[lang]?.button2 || { link: "/contact", text: "Зв’язатись з нами" },
        };
      });

      await api.put(`/site-settings/${editing.id}`, { value: merged });
      alert("✅ Успішно збережено!");
    } catch (err) {
      console.error("Помилка збереження:", err);
      alert("❌ Не вдалося зберегти. Перевір консоль.");
    }
  };

  return (
    <div className="mt-4">
      {/* Вибір мови */}
      <div className="mb-4 flex gap-2">
        {["ua", "en"].map((lang) => (
          <button
            key={lang}
            className={`px-4 py-2 rounded ${currentLang === lang ? "bg-blue-500 text-white" : "bg-gray-200"}`}
            onClick={() => setCurrentLang(lang)}
          >
            {lang.toUpperCase()}
          </button>
        ))}
      </div>

      {/* Форма редагування */}
      <div className="mb-4 border p-2 rounded">
        <label className="block mb-1 font-medium">Title:</label>
        <input
          type="text"
          className="w-full p-2 border rounded mb-2"
          value={form[currentLang]?.title || ""}
          onChange={(e) => handleChange(`${currentLang}.title`, e.target.value)}
        />

        <label className="block mb-1 font-medium">Description:</label>
        <textarea
          className="w-full p-2 border rounded mb-2"
          value={form[currentLang]?.description || ""}
          onChange={(e) => handleChange(`${currentLang}.description`, e.target.value)}
        />

        <label className="block mb-1 font-medium">Image:</label>
        <input type="file" onChange={handleImageUpload} />
        {form[currentLang]?.image && (
          <img
            src={form[currentLang].image}
            alt="preview"
            className="mt-2 w-48 h-auto object-cover rounded shadow"
          />
        )}
      </div>

      <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={saveEdit}>
        Зберегти
      </button>

      {/* Попередній перегляд */}
      <div className="mt-6">
        <h3 className="text-lg mb-2 font-bold">
          Попередній перегляд ({currentLang.toUpperCase()})
        </h3>
        <section className="relative bg-[#ebe1d5ff] rounded-2xl overflow-hidden my-6 shadow-inner p-4">
          <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 items-center gap-6">
            <div className="relative w-full order-1 md:order-2">
              <div className="relative w-full aspect-[4/3] md:h-[320px] overflow-hidden rounded-lg">
                <img
                  src={form[currentLang]?.image || "/images/placeholder.jpg"}
                  alt="Hero preview"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            <div className="order-2 md:order-1 px-4 py-4 space-y-4">
              <h1 className="text-3xl font-semibold" style={{ color: "#4A3B30" }}>
                {form[currentLang]?.title || "Тут буде заголовок"}
              </h1>
              <p style={{ color: "#4A3B30" }}>
                {form[currentLang]?.description || "Тут буде опис HeroSection"}
              </p>
              <div className="flex gap-3">
                <a
                  href={editing?.value?.[currentLang]?.button1?.link || "/catalog"}
                  className="px-4 py-2 bg-[#4A3B30] text-[#F5E0C3] rounded"
                >
                  {editing?.value?.[currentLang]?.button1?.text || "Переглянути колекцію"}
                </a>
                <a
                  href={editing?.value?.[currentLang]?.button2?.link || "/contact"}
                  className="px-4 py-2 border border-[#4A3B30] text-[#4A3B30] rounded"
                >
                  {editing?.value?.[currentLang]?.button2?.text || "Зв’язатись з нами"}
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default HeroSectionEdit;




// import React, { useState, useEffect } from "react";
// import api from "../api";
// import { fetchSettings } from "../services/siteSettingsService"; // тільки ця функція потрібна

// const HeroSectionEdit = ({ editing }) => {
//   const [currentLang, setCurrentLang] = useState("ua");
//   const [form, setForm] = useState({
//     ua: {
//       title: "",
//       description: "",
//       image: "",
//       button1: { text: "", link: "" },
//       button2: { text: "", link: "" },
//     },
//     en: {
//       title: "",
//       description: "",
//       image: "",
//       button1: { text: "", link: "" },
//       button2: { text: "", link: "" },
//     },
//   });

//   useEffect(() => {
//     if (editing?.value) {
//       setForm(editing.value);
//     }
//   }, [editing]);

//   const handleChange = (path, value) => {
//     const keys = path.split(".");
//     setForm((prev) => {
//       const updated = { ...prev };
//       let obj = updated;
//       keys.forEach((k, i) => {
//         if (i === keys.length - 1) obj[k] = value;
//         else obj[k] = { ...obj[k] };
//         obj = obj[k];
//       });
//       return updated;
//     });
//   };

//   const handleImageUpload = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
//     const uploadPreset = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

//     if (!cloudName || !uploadPreset) {
//       alert("Cloudinary не налаштовано. Перевір .env");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("file", file);
//     formData.append("upload_preset", uploadPreset);

//     try {
//       const res = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/image/upload`, {
//         method: "POST",
//         body: formData,
//       });

//       const data = await res.json();
//       if (data.secure_url) {
//         handleChange(`${currentLang}.image`, data.secure_url);
//       } else {
//         console.error("Cloudinary Error:", data);
//         alert("Помилка при завантаженні зображення. Перевір консоль.");
//       }
//     } catch (err) {
//       console.error("Помилка завантаження:", err);
//       alert("Не вдалося завантажити зображення");
//     }
//   };

//   const saveEdit = async () => {
//     try {
//       await api.put(`/site-settings/${editing.id}`, { value: form });
//       await fetchSettings(); // оновлення налаштувань після збереження
//       alert("✅ Успішно збережено!");
//     } catch (err) {
//       console.error("Помилка збереження:", err);
//       alert("❌ Не вдалося зберегти. Перевір консоль.");
//     }
//   };

//   return (
//     <div className="mt-4">
//       {/* Вибір мови */}
//       <div className="mb-4 flex gap-2">
//         {["ua", "en"].map((lang) => (
//           <button
//             key={lang}
//             className={`px-4 py-2 rounded ${currentLang === lang ? "bg-blue-500 text-white" : "bg-gray-200"}`}
//             onClick={() => setCurrentLang(lang)}
//           >
//             {lang.toUpperCase()}
//           </button>
//         ))}
//       </div>

//       {/* Форма редагування */}
//       <div className="mb-4 border p-2 rounded">
//         <label className="block mb-1 font-medium">Title:</label>
//         <input
//           type="text"
//           className="w-full p-2 border rounded mb-2"
//           value={form[currentLang]?.title || ""}
//           onChange={(e) => handleChange(`${currentLang}.title`, e.target.value)}
//         />

//         <label className="block mb-1 font-medium">Description:</label>
//         <textarea
//           className="w-full p-2 border rounded mb-2"
//           value={form[currentLang]?.description || ""}
//           onChange={(e) => handleChange(`${currentLang}.description`, e.target.value)}
//         />

//         <label className="block mb-1 font-medium">Image:</label>
//         <input type="file" onChange={handleImageUpload} />
//         {form[currentLang]?.image && (
//           <img
//             src={form[currentLang].image}
//             alt="preview"
//             className="mt-2 w-48 h-auto object-cover rounded shadow"
//           />
//         )}

//         <h4 className="font-semibold mt-3">Button 1</h4>
//         <input
//           type="text"
//           className="w-full p-2 border rounded mb-1"
//           value={form[currentLang]?.button1?.text || ""}
//           onChange={(e) => handleChange(`${currentLang}.button1.text`, e.target.value)}
//           placeholder="Text"
//         />
//         <input
//           type="text"
//           className="w-full p-2 border rounded mb-2"
//           value={form[currentLang]?.button1?.link || ""}
//           onChange={(e) => handleChange(`${currentLang}.button1.link`, e.target.value)}
//           placeholder="Link"
//         />

//         <h4 className="font-semibold mt-3">Button 2</h4>
//         <input
//           type="text"
//           className="w-full p-2 border rounded mb-1"
//           value={form[currentLang]?.button2?.text || ""}
//           onChange={(e) => handleChange(`${currentLang}.button2.text`, e.target.value)}
//           placeholder="Text"
//         />
//         <input
//           type="text"
//           className="w-full p-2 border rounded mb-2"
//           value={form[currentLang]?.button2?.link || ""}
//           onChange={(e) => handleChange(`${currentLang}.button2.link`, e.target.value)}
//           placeholder="Link"
//         />
//       </div>

//       <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={saveEdit}>
//         Зберегти
//       </button>

//       {/* Попередній перегляд */}
//       <div className="mt-6">
//         <h3 className="text-lg mb-2 font-bold">
//           Попередній перегляд ({currentLang.toUpperCase()})
//         </h3>
//         <section className="relative bg-[#ebe1d5ff] rounded-2xl overflow-hidden my-6 shadow-inner p-4">
//           <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 items-center gap-6">
//             <div className="relative w-full order-1 md:order-2">
//               <div className="relative w-full aspect-[4/3] md:h-[320px] overflow-hidden rounded-lg">
//                 <img
//                   src={form[currentLang]?.image || "/images/placeholder.jpg"}
//                   alt="Hero preview"
//                   className="w-full h-full object-cover"
//                 />
//               </div>
//             </div>

//             <div className="order-2 md:order-1 px-4 py-4 space-y-4">
//               <h1 className="text-3xl font-semibold" style={{ color: "#4A3B30" }}>
//                 {form[currentLang]?.title || "Тут буде заголовок"}
//               </h1>
//               <p style={{ color: "#4A3B30" }}>
//                 {form[currentLang]?.description || "Тут буде опис HeroSection"}
//               </p>
//               <div className="flex gap-3">
//                 <a
//                   href={form[currentLang]?.button1?.link || "#"}
//                   className="px-4 py-2 bg-[#4A3B30] text-[#F5E0C3] rounded"
//                 >
//                   {form[currentLang]?.button1?.text || "Кнопка 1"}
//                 </a>
//                 <a
//                   href={form[currentLang]?.button2?.link || "#"}
//                   className="px-4 py-2 border border-[#4A3B30] text-[#4A3B30] rounded"
//                 >
//                   {form[currentLang]?.button2?.text || "Кнопка 2"}
//                 </a>
//               </div>
//             </div>
//           </div>
//         </section>
//       </div>
//     </div>
//   );
// };

// export default HeroSectionEdit;



